// Stock photography for job cards and employer stories. Employers who upload
// their own workplace photo always win; otherwise a photo matching the industry
// keeps every posting from looking like the same grey box.
const INDUSTRY_PHOTOS = {
  Technology: [
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=70",
  ],
  Healthcare: [
    "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1200&q=70",
  ],
  Finance: [
    "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1200&q=70",
  ],
  Retail: [
    "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?auto=format&fit=crop&w=1200&q=70",
  ],
  Education: [
    "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1200&q=70",
  ],
  Hospitality: [
    "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1200&q=70",
  ],
  Manufacturing: [
    "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&q=70",
  ],
  Construction: [
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=70",
  ],
  Government: [
    "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?auto=format&fit=crop&w=1200&q=70",
    "https://images.unsplash.com/photo-1541872703-74c5e44368f9?auto=format&fit=crop&w=1200&q=70",
  ],
};

const GENERIC_PHOTOS = [
  "https://images.unsplash.com/photo-1521737604893-d22e68d0f6b0?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=70",
];

const TILE_TONES = [
  "bg-[#c8102e]",
  "bg-[#171717]",
  "bg-[#1f4e79]",
  "bg-[#2f6b4f]",
  "bg-[#7a3e12]",
  "bg-[#4b3a86]",
];

function hash(value) {
  return String(value || "").split("").reduce((total, char) => (total * 31 + char.charCodeAt(0)) % 997, 7);
}

/** The photo that sits behind a job card: the employer's own, else stock for the industry. */
export function jobImage(job = {}) {
  const own = job.cover_image || job.company_image || job.image_url;
  if (own) return own;
  const byIndustry = INDUSTRY_PHOTOS[job.industry];
  if (byIndustry) return byIndustry[hash(job.company || job.title) % byIndustry.length];
  return GENERIC_PHOTOS[hash(job.company || job.title) % GENERIC_PHOTOS.length];
}

/** Initials for the monogram shown when an employer has not uploaded a logo. */
export function companyInitials(name) {
  const words = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "PR";
  return words.slice(0, 2).map((word) => word[0]).join("").toUpperCase();
}

/** A stable tile color per company, so monograms are not all the same red. */
export function companyTone(name) {
  return TILE_TONES[hash(name) % TILE_TONES.length];
}